import PropTypes from 'prop-types';
// @mui
import { Box, useTheme } from '@mui/material';

export enum ChipType {
	APPROVED = 'approved',
	ERROR = 'error',
	REGULAR = 'regular',
	GRAYED = 'grayed',
	NATURAL = 'natural',
}
interface IBaseProps {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
}

export const LightGreenChip = (props: IBaseProps) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				padding: '4px 8px',
				backgroundColor: theme.palette.root.darkGrayed_024,
				borderRadius: '8px',
			}}
		>
			{props.children}
		</Box>
	);
};

interface IOrangeCircle {
	children?: any;
	styleObj?: any;
}

export const OrangeCircle = (props: IOrangeCircle) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				width: '4px',
				height: '4px',
				background: theme.palette.root.orange_3,
				borderRadius: '50%',
				...props.styleObj,
			}}
		>
			{props.children}
		</Box>
	);
};
